import { render, staticRenderFns } from "./OtherChargeGrid.vue?vue&type=template&id=3b326600&scoped=true&"
import script from "./OtherChargeGrid.vue?vue&type=script&lang=js&"
export * from "./OtherChargeGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b326600",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b326600')) {
      api.createRecord('3b326600', component.options)
    } else {
      api.reload('3b326600', component.options)
    }
    module.hot.accept("./OtherChargeGrid.vue?vue&type=template&id=3b326600&scoped=true&", function () {
      api.rerender('3b326600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/OtherChargeGrid.vue"
export default component.exports